import addRoute from '@/router/add-route';

const Segments = () => import('@/modules/segments/segments.vue');
const SegmentManagement = () => import('@/modules/segments/segment-management.vue');
const SegmentForm = () => import('@/modules/segments/segment-form.vue');
const ListsView = () => import('@/modules/segments/lists');

const segments = [
    addRoute({
        name: 'segments',
        path: '/segments',
        component: Segments,
    }),
    addRoute({
        name: 'segment-management',
        path: '/segment-management/:page?/:category?',
        component: SegmentManagement,
    }),
    addRoute({
        name: 'add-segment',
        path: '/segments/add/:page?',
        component: SegmentForm,
    }),
    addRoute({
        name: 'lists',
        path: '/lists/:segmentId?',
        component: ListsView,
    }),
    addRoute({
        name: 'resource-log',
        path: '/logs/:type/:resourceId',
        component: ListsView,
    }),
    addRoute({
        name: 'resource-customers',
        path: '/lists/:type/:resourceId',
        component: ListsView,
    }),
];

export default segments;
